export default "__VITE_ASSET__BlEYpX3W__"